var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"small":"","card":""}},[_c('download-documents',{attrs:{"active":""}}),(_vm.activeUser.isAnAdministrator())?_c('b-tab',{attrs:{"title":"Upload Documents","lazy":""}},[_vm._v(" upload will be done at a later time. ")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }